export const HERO_IMG =
  "https://images.unsplash.com/photo-1556910602-38f53e68e15d?crop=entropy&cs=srgb&fm=jpg&q=85";

export const PROBLEMS = [
  {
    id: "espacio",
    label: "Poco espacio en casa",
    title: "¿Poco espacio en casa?",
    text: "Soluciones de almacenamiento que aprovechan cada rincón sin obras ni muebles nuevos.",
    tag: "espacio",
  },
  {
    id: "limpieza",
    label: "Pierdo tiempo limpiando",
    title: "¿Pierdes demasiado tiempo limpiando?",
    text: "Accesorios prácticos que recortan la limpieza diaria a la mitad de esfuerzo.",
    tag: "limpieza",
  },
  {
    id: "cocina",
    label: "Cocina desorganizada",
    title: "¿Tu cocina está desorganizada?",
    text: "Utensilios y organizadores para cocinar más rápido y encontrar todo a la primera.",
    tag: "cocina",
  },
  {
    id: "cables",
    label: "Cables por todas partes",
    title: "¿Tienes cables por todas partes?",
    text: "Accesorios sencillos para ordenar cargadores, regletas y el escritorio.",
    tag: "cables",
  },
  {
    id: "viaje",
    label: "Preparo un viaje",
    title: "¿Preparas un viaje?",
    text: "Productos que facilitan el equipaje y quitan complicaciones desde que haces la maleta.",
    tag: "viaje",
  },
  {
    id: "coche",
    label: "Coche desordenado",
    title: "¿Quieres mantener el coche organizado?",
    text: "Accesorios útiles para que el maletero y el habitáculo dejen de ser un caos.",
    tag: "coche",
  },
];

const IMG_CAT = {
  organizacion:
    "https://images.unsplash.com/photo-1644463589256-02679b9c0767?crop=entropy&cs=srgb&fm=jpg&q=85",
  cocina:
    "https://images.unsplash.com/photo-1556037843-347ddff9f4b0?crop=entropy&cs=srgb&fm=jpg&q=85",
  oficina:
    "https://images.pexels.com/photos/35709485/pexels-photo-35709485.jpeg?auto=compress&cs=tinysrgb&w=800",
  coche:
    "https://images.pexels.com/photos/33980838/pexels-photo-33980838.jpeg?auto=compress&cs=tinysrgb&w=800",
  viajes:
    "https://images.unsplash.com/photo-1634839763563-97d93f8131c6?crop=entropy&cs=srgb&fm=jpg&q=85",
  mascotas:
    "https://images.pexels.com/photos/16440218/pexels-photo-16440218.jpeg?auto=compress&cs=tinysrgb&w=800",
  jardin:
    "https://images.pexels.com/photos/14419082/pexels-photo-14419082.jpeg?auto=compress&cs=tinysrgb&w=800",
  salud:
    "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?crop=entropy&cs=srgb&fm=jpg&q=85",
  hogar:
    "https://images.pexels.com/photos/5217896/pexels-photo-5217896.jpeg?auto=compress&cs=tinysrgb&w=800",
  tecnologia:
    "https://images.unsplash.com/photo-1515940175183-6798529cb860?crop=entropy&cs=srgb&fm=jpg&q=85",
  cuidado:
    "https://images.pexels.com/photos/12969358/pexels-photo-12969358.jpeg?auto=compress&cs=tinysrgb&w=800",
  bricolaje:
    "https://images.pexels.com/photos/5414384/pexels-photo-5414384.jpeg?auto=compress&cs=tinysrgb&w=800",
  regalos:
    "https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=800&auto=format&fit=crop&q=80",
  regalosNavidad:
    "https://images.pexels.com/photos/6232610/pexels-photo-6232610.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  regalosVerano:
    "https://images.pexels.com/photos/8185803/pexels-photo-8185803.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  regalosCole:
    "https://images.unsplash.com/photo-1535982330050-f1c2fb79ff78?crop=entropy&cs=srgb&fm=jpg&q=85",
  ofertas:
    "https://images.unsplash.com/photo-1664455340023-214c33a9d0bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxvbmxpbmUlMjBzaG9wcGluZyUyMGRpc2NvdW50JTIwY2FydCUyMHNhbGUlMjBib3h8ZW58MHx8fHwxNzkzNzEwMzMwfDA&ixlib=rb-4.1.0&q=85",
};

export const GUIDES = [
  {
    slug: "organizar-casa-pequena",
    title: "Cómo organizar una casa pequeña sin obras ni agobios",
    excerpt:
      "Trucos realistas y productos sencillos para ganar espacio en armarios, entrada y baño cuando los metros no acompañan.",
    image: IMG_CAT.organizacion,
    minutes: 4,
    category: "organizacion-y-almacenamiento",
    products: ["amazon-basics-bolsas-vacio-5", "amazon-basics-perchas-terciopelo-50", "lifewit-cajas-ropa-35l"],
    intro:
      "Vivir en una casa pequeña no significa vivir entre cajas. Con unas cuantas decisiones bien tomadas (y algunos accesorios baratos) es posible duplicar la sensación de orden sin mover ni un solo mueble pesado.",
    sections: [
      {
        heading: "Aprovecha la vertical antes que el suelo",
        body: "El espacio que más se desperdicia está en altura: el interior de los armarios, la zona sobre las puertas o el hueco bajo las baldas. Zapateros apilables, perchas multicapa y cestas colgantes convierten aire en almacenamiento útil.",
      },
      {
        heading: "Comprime lo que no usas",
        body: "La ropa de otra temporada, los edredones y las mantas ocupan un volumen enorme la mitad del año. Las bolsas de vacío reducen ese volumen hasta un 80 % y caben debajo de la cama o en lo alto del armario.",
      },
      {
        heading: "Un lugar para cada cosa (de verdad)",
        body: "El desorden crónico suele ser un problema de destino, no de espacio: si las llaves, los cargadores o el correo no tienen un sitio fijo, acaban en cualquier sitio. Un organizador de cajones o una bandeja en la entrada resuelven más que un armario nuevo.",
      },
    ],
    tips: [
      "Mide antes de comprar cualquier organizador: 2 cm de más lo inutilizan.",
      "Vacía el cajón entero antes de ordenarlo; reorganizar sobre el caos no funciona.",
      "Lo que no se ha usado en un año, probablemente no necesita un hueco en casa.",
    ],
  },
  {
    slug: "accesorios-cocina-diaria",
    title: "Accesorios de cocina que de verdad facilitan las tareas diarias",
    excerpt:
      "Ni gadgets imposibles ni trastos que acaban en un cajón: utensilios sencillos que se usan cada día y se agradecen desde la primera semana.",
    image: IMG_CAT.cocina,
    minutes: 4,
    category: "cocina-y-utensilios",
    products: ["grifema-bascula-cocina", "trendplain-spray-aceite", "edihome-papel-freidora"],
    intro:
      "La cocina es la estancia donde más claramente se nota la diferencia entre un accesorio bien pensado y uno comprado por impulso. Esta selección se limita a herramientas que resuelven tareas repetitivas: pesar, ordenar, conservar y limpiar.",
    sections: [
      {
        heading: "Pesar bien es cocinar mejor",
        body: "Una báscula digital de 1 gramo de precisión cambia la repostería, las dietas y hasta el café. Con función tara se pesa directamente en el bol y desaparecen las medidas «a ojo» que estropean recetas.",
      },
      {
        heading: "Especias a la vista, cocina más rápida",
        body: "Buscamos las especias varias veces al día; si viven amontonadas al fondo de un armario, cada búsqueda roba tiempo. Un organizador giratorio las pone todas a la vista con un giro de muñeca.",
      },
      {
        heading: "Menos plástico de un solo uso",
        body: "Las tapas de silicona extensibles sustituyen al film transparente en boles, vasos y fruta cortada. Se lavan en el lavavajillas y se amortizan en pocas semanas de uso diario.",
      },
    ],
    tips: [
      "Compra pensando en la tarea, no en el aparato: ¿qué haces cada día que te molesta?",
      "Si un utensilio no cabe en el lavavajillas, probablemente lo usarás menos.",
      "Un solo organizador bueno vale más que cinco artilugios de moda.",
    ],
  },
  {
    slug: "escritorio-ordenado",
    title: "Ideas sencillas para mantener el escritorio ordenado",
    excerpt:
      "Cables bajo control, lo esencial a mano y la pantalla a la altura correcta: pequeños cambios que se notan desde el primer lunes.",
    image: IMG_CAT.oficina,
    minutes: 3,
    category: "oficina-y-productividad",
    products: ["torre-regleta-8-usb", "enchufe-plano-giratorio", "niimbot-d110"],
    intro:
      "Un escritorio desordenado no es solo una cuestión estética: cada cable suelto y cada objeto fuera de sitio es una pequeña distracción repetida cientos de veces al día. Ordenarlo bien una vez cuesta menos de lo que parece.",
    sections: [
      {
        heading: "Primero, los cables",
        body: "El 80 % del desorden visual de un escritorio son cables. Una caja organizadora oculta la regleta entera, unas bridas de velcro agrupan lo que cuelga y unos clips adhesivos dejan cada cargador siempre en el borde de la mesa.",
      },
      {
        heading: "La pantalla, a tu altura",
        body: "Trabajar con el portátil bajo fuerza el cuello durante horas. Un soporte elevador pone la pantalla a la altura de los ojos, mejora la postura y libera espacio debajo para el teclado o los documentos.",
      },
      {
        heading: "Lo que usas a diario, visible; lo demás, guardado",
        body: "Un organizador de sobremesa con compartimentos mantiene bolis, notas y auriculares a mano sin invadir la zona de trabajo. La regla es simple: si no lo usas a diario, no merece estar sobre la mesa.",
      },
    ],
    tips: [
      "Desconecta todo antes de ordenar los cables: es la única forma de hacerlo bien.",
      "Etiqueta los cargadores que se parecen; ahorrarás pruebas a diario.",
      "Cinco minutos de orden al cerrar el día evitan el caos del lunes.",
    ],
  },
  {
    slug: "organizar-el-coche",
    title: "Soluciones prácticas para mantener el coche organizado",
    excerpt:
      "Del maletero que se traga la compra al habitáculo lleno de cosas sueltas: accesorios que ponen orden en el coche sin gastar de más.",
    image: IMG_CAT.coche,
    minutes: 3,
    category: "accesorios-coche",
    products: ["sisbrill-361", "california-scents", "hovvida-compresor"],
    intro:
      "El coche acumula desorden a una velocidad sorprendente: la compra que rueda por el maletero, los cables sueltos, los juguetes de los niños. Con tres o cuatro accesorios bien elegidos se puede mantener impecable sin esfuerzo diario.",
    sections: [
      {
        heading: "El maletero, bajo control",
        body: "Un organizador plegable con compartimentos evita que bolsas y objetos rueden en cada curva. Cuando no hace falta, se pliega plano y apenas ocupa; cuando toca compra grande, las asas permiten sacarlo todo de una vez.",
      },
      {
        heading: "El móvil, siempre en su sitio",
        body: "Un soporte magnético firme convierte el móvil en navegador seguro: a la vista, sin soltar el volante y sin inventos con ventosas que se caen en verano.",
      },
      {
        heading: "Limpieza de cinco minutos",
        body: "Un aspirador de mano de 12V resuelve migas, arena y pelos de mascota sin depender de las máquinas de la gasolinera. Con un organizador de respaldo, además, los pasajeros dejan de pisotear sus propias cosas.",
      },
    ],
    tips: [
      "Vacía el maletero una vez al mes: pesa más de lo que crees y gasta combustible.",
      "Un organizador que molesta acaba en el garaje; elige modelos plegables.",
      "Comprueba las medidas del hueco antes de comprar cualquier organizador de coche.",
    ],
  },
  {
    slug: "viajar-sin-complicaciones",
    title: "Accesorios útiles para viajar con menos complicaciones",
    excerpt:
      "Hacer la maleta deja de ser un puzzle cuando cada cosa tiene su cubo, su botella y su peso medido antes de salir de casa.",
    image: IMG_CAT.viajes,
    minutes: 4,
    category: "viajes",
    products: ["hayayu-mochila-ryanair", "suoco-bolsas-vacio-bomba", "matein-mochila-expandible"],
    intro:
      "La diferencia entre un viaje cómodo y uno estresante suele decidirse antes de cerrar la maleta. Estos accesorios atacan los tres clásicos del equipaje: el desorden, los líquidos y el sobrepeso.",
    sections: [
      {
        heading: "Cubos organizadores: la maleta, por capítulos",
        body: "Las bolsas organizadoras separan ropa, zapatos y cables en volúmenes compactos. Se deshace la maleta en minutos, se encuentra todo sin revolver y la ropa llega mucho menos arrugada.",
      },
      {
        heading: "Líquidos sin sustos en el control",
        body: "Unas botellas de silicona de 100 ml rellenables permiten llevar tus productos de siempre en cabina, sin comprar minis caros ni arriesgarse a que el champú explote sobre la ropa.",
      },
      {
        heading: "El peso, medido en casa",
        body: "Descubrir el sobrepeso en el mostrador del aeropuerto sale caro. Una báscula de equipaje portátil pesa la maleta en casa y en el hotel, y cabe en cualquier bolsillo para el viaje de vuelta.",
      },
    ],
    tips: [
      "Enrolla la ropa dentro de los cubos: ocupa menos y se arruga menos.",
      "Lleva una bolsa organizadora vacía para la ropa usada de la vuelta.",
      "Pesa la maleta de vuelta antes de salir del hotel, no en la cola del aeropuerto.",
    ],
  },
  {
    slug: "mascotas-sin-complicaciones",
    title: "Cuidados diarios de perros y gatos sin complicaciones",
    excerpt:
      "Beber más agua, paseos sin barro en casa y un arenero que no se nota: rutinas cortas y accesorios que hacen la convivencia más fácil.",
    image: IMG_CAT.mascotas,
    minutes: 4,
    category: "mascotas",
    products: ["fuente-gatos-acero", "earth-rated-toallitas", "menforsan-champu"],
    intro:
      "Convivir con una mascota es de las mejores cosas de una casa, pero también son pelos, patas con barro y rutinas que se acumulan. La clave no es dedicar más tiempo, sino tener los accesorios adecuados en el sitio adecuado.",
    sections: [
      {
        heading: "Agua siempre fresca: que beban más sin esfuerzo",
        body: "Muchos gatos y perros pequeños beben menos de lo recomendable porque el agua quieta del cuenco no les atrae. Una fuente con agua en movimiento despierta su instinto y aumenta su hidratación diaria sin que tengas que hacer nada.",
      },
      {
        heading: "La higiene en cinco minutos",
        body: "Unas toallitas junto a la puerta resuelven las patas con barro al volver del paseo, antes de que lleguen al sofá. Para el baño, un champú específico con aloe vera cuida su piel sin irritarla: la piel de perros y gatos tiene un pH distinto al nuestro.",
      },
      {
        heading: "El arenero y los paseos, bajo control",
        body: "Una arena aglomerante permite retirar a diario solo lo usado y el arenero dura semanas sin olores. Y tener el dispensador de bolsas enganchado a la correa acaba para siempre con el «me he olvidado las bolsas».",
      },
    ],
    tips: [
      "Introduce cualquier accesorio nuevo poco a poco: deja que lo huela un par de días antes de usarlo.",
      "Una rutina corta a diario vale más que una sesión larga el fin de semana.",
      "Guarda las bolsas de paseo enganchadas a la correa: si están a la vista, no se olvidan.",
    ],
  },
  {
    slug: "jardin-y-terraza-facil",
    title: "Cuidar las plantas y la terraza sin ser un experto",
    excerpt:
      "Tierra adecuada, riego sin excesos y muebles protegidos: tres decisiones que mantienen el jardín o la terraza en forma con muy poco trabajo.",
    image: IMG_CAT.jardin,
    minutes: 4,
    category: "jardin-y-exteriores",
    products: ["flower-sustrato-10l", "compo-abono-plantas", "enzeno-funda-mesa"],
    intro:
      "No hace falta mano con las plantas: hace falta acertar con lo básico. La mayoría de los problemas de un jardín o una terraza vienen de tres cosas — la tierra, el riego y la intemperie — y las tres tienen solución sencilla.",
    sections: [
      {
        heading: "El sustrato lo es casi todo",
        body: "Una planta en tierra pobre o apelmazada nunca llega a desarrollarse, riegues lo que riegues. Un sustrato universal de calidad con perlita aireado da a las raíces el oxígeno y el drenaje que necesitan desde el primer día.",
      },
      {
        heading: "Riega menos, pero mejor",
        body: "Más plantas mueren por exceso de riego que por sequía. Regar solo cuando la tierra está seca y aportar un abono líquido cada pocas semanas en temporada mantiene las hojas verdes sin rutinas complicadas.",
      },
      {
        heading: "Protege el mueble de exterior antes del temporal",
        body: "El sol y la lluvia envejecen una mesa de terraza en una sola temporada. Una funda impermeable con sujeción antiviento alarga la vida del conjunto años enteros y ahorra limpiezas profundas cada primavera.",
      },
    ],
    tips: [
      "Mete el dedo unos 2 cm en la tierra: si está húmeda, espera antes de regar.",
      "Las plantas perdonan mucho más un riego escaso que uno excesivo.",
      "Cubre los muebles antes del primer temporal de otoño, no después.",
    ],
  },
  {
    slug: "bienestar-en-casa",
    title: "Pequeños hábitos de bienestar que sí se mantienen",
    excerpt:
      "Sin propósitos imposibles: medir lo básico, mejorar la higiene diaria y descansar mejor con ayudas sencillas que caben en cualquier rutina.",
    image: IMG_CAT.salud,
    minutes: 4,
    category: "salud-y-bienestar",
    products: ["oralb-vitality-pro", "vimmk-irrigador", "bascula-bano-led"],
    intro:
      "El bienestar que dura no viene de cambios radicales, sino de pequeños hábitos que cuestan tan poco que no se abandonan. Estos tres frentes — medir, la higiene diaria y la recuperación — son los que más notan la mayoría de las personas.",
    sections: [
      {
        heading: "Medir ayuda: datos sencillos, decisiones mejores",
        body: "No se trata de obsesionarse con los números, sino de tener referencias: una báscula fiable para seguir la evolución del peso o un tensiómetro si tu médico te ha recomendado controlar la tensión en casa convierten sensaciones en datos útiles.",
      },
      {
        heading: "La higiene bucal va más allá del cepillo manual",
        body: "Un cepillo eléctrico con temporizador asegura los dos minutos completos que recomienda cualquier dentista, y un irrigador llega donde el cepillo no puede: entre los dientes y bajo la línea de las encías. Es la diferencia entre «me lo he cepillado» y una limpieza completa.",
      },
      {
        heading: "Recuperar también es cuidarse",
        body: "Dormir bien, estirar cinco minutos y llevar una alimentación equilibrada son la base. Si te planteas algún complemento (magnesio, omega 3, colágeno...), hazlo siempre como apoyo y consultando antes con un profesional sanitario.",
      },
    ],
    tips: [
      "Si sigues tu peso, pésate siempre a la misma hora y en las mismas condiciones.",
      "Dos minutos de cepillado con temporizador valen más que cinco a toda prisa.",
      "Antes de tomar cualquier suplemento, consulta con tu médico o farmacéutico.",
    ],
  },
  {
    slug: "limpieza-rapida-casa",
    title: "La limpieza rápida de la casa: el método de los 15 minutos",
    excerpt:
      "Olvídate de la limpieza maratoniana del sábado: repartir la casa en mini-sesiones diarias la mantiene presentable sin esfuerzo.",
    image: IMG_CAT.hogar,
    minutes: 4,
    category: "hogar-y-limpieza",
    products: ["vileda-purmicro-bayetas", "mopa-spray-3-pads", "scrub-daddy-scrub-mommy"],
    intro:
      "La casa no se ensucia de golpe: se ensucia un poco cada día. Por eso funciona mejor limpiar un poco cada día. El método de los 15 minutos consiste en atacar una sola zona por jornada con las herramientas adecuadas ya preparadas.",
    sections: [
      {
        heading: "El truco es la constancia, no la maratón",
        body: "Quince minutos diarios suman casi dos horas semanales sin que ningún día resulte pesado. Lunes el baño, martes el polvo del salón, miércoles la cocina... La casa nunca llega al punto de necesitar una gran limpieza.",
      },
      {
        heading: "Las herramientas adecuadas, siempre a mano",
        body: "Una mopa con spray integrado elimina el ritual del cubo y la fregona: rocías y friegas en una pasada. Unas buenas bayetas de microfibra, repartidas por colores según la estancia, evitan mezclar la suciedad del baño con la cocina.",
      },
      {
        heading: "Cocina y baño: los dos frentes críticos",
        body: "Son las estancias donde la suciedad se nota antes y donde más importa la higiene. Un estropajo de doble cara resuelve tanto la sartén pegada como la mampara sin arañar, y dejarlo todo recogido cada noche hace que la casa amanezca ordenada.",
      },
    ],
    tips: [
      "Pon un temporizador de 15 minutos: cuando suena, paras. Mañana sigues.",
      "Reparte las bayetas por colores: una para cocina, otra para baño, otra para el resto.",
      "Guarda los productos de limpieza donde se usan, no todos en un mismo armario.",
    ],
  },
  {
    slug: "tecnologia-util-diaria",
    title: "Tecnología práctica: accesorios que sí se usan a diario",
    excerpt:
      "Ni cacharros que acaban en un cajón ni aparatos imposibles de configurar: tecnología sencilla que resuelve algo concreto desde el primer día.",
    image: IMG_CAT.tecnologia,
    minutes: 4,
    category: "tecnologia-y-moviles",
    products: ["echo-dot-5", "torre-regleta-8-usb", "tapo-c210-camara"],
    intro:
      "La buena tecnología doméstica se reconoce por una cosa: se usa todos los días sin pensar. Esta selección evita los gadgets de moda y se centra en tres necesidades reales de cualquier casa: los enchufes, el control por voz y la tranquilidad.",
    sections: [
      {
        heading: "Primero la base: enchufes y carga",
        body: "El problema tecnológico más común de una casa no es la falta de aparatos, sino la falta de enchufes. Una regleta en torre con puertos USB junto al sofá o el escritorio acaba con la guerra por el cargador y con los cables cruzando el suelo.",
      },
      {
        heading: "La casa que responde a tu voz",
        body: "Un altavoz inteligente pequeño hace de temporizador de cocina, despertador, hilo musical y mando de las luces. Cuesta menos que muchos accesorios decorativos y se convierte en el aparato más usado de la casa.",
      },
      {
        heading: "Tranquilidad cuando no estás",
        body: "Una cámara de interior con aviso al móvil permite echar un vistazo a la casa, a la mascota o a los abuelos desde cualquier lugar. Se configura en cinco minutos y solo avisa cuando detecta movimiento.",
      },
    ],
    tips: [
      "Antes de comprar un gadget, pregúntate: ¿lo usaré más de tres veces por semana?",
      "Un solo dispositivo bien colocado rinde más que tres mal repartidos.",
      "Cambia la contraseña por defecto de cualquier cámara o enchufe inteligente el primer día.",
    ],
  },
  {
    slug: "cuidado-personal-basico",
    title: "Cuidado personal: los básicos que de verdad se notan",
    excerpt:
      "Sin rutinas de diez pasos ni productos milagro: tres básicos bien elegidos para el pelo y la piel que sí se mantienen en el tiempo.",
    image: IMG_CAT.cuidado,
    minutes: 4,
    category: "cuidado-personal",
    products: ["revlon-uniqone", "lrp-cicaplast", "cerave-blemish"],
    intro:
      "El cuidado personal efectivo no es el más largo ni el más caro: es el que se repite cada día. Con tres básicos bien elegidos — uno para el pelo, uno para la limpieza facial y un multiusos para imprevistos — se cubre el 90 % del día a día.",
    sections: [
      {
        heading: "El pelo: proteger antes que reparar",
        body: "El secador y la plancha dañan el cabello un poco cada día, y el daño acumulado no se arregla con mascarillas. Un protector térmico aplicado antes de peinar es el gesto más barato y efectivo para mantenerlo sano.",
      },
      {
        heading: "La piel: una limpieza suave que no falte",
        body: "Limpiar la cara por la mañana y por la noche con un gel suave es la base sobre la que todo lo demás funciona. Los limpiadores con ceramidas o ácido salicílico limpian en profundidad sin resecar ni irritar.",
      },
      {
        heading: "Un multiusos para los imprevistos",
        body: "Rozaduras, irritaciones, piel seca después del sol o del frío: un bálsamo reparador multiusos en el botiquín resuelve la mayoría de pequeñas urgencias de la piel de toda la familia.",
      },
    ],
    tips: [
      "Menos productos usados a diario funcionan mejor que diez usados una vez.",
      "Aplica el protector térmico con el pelo húmedo, antes de cualquier fuente de calor.",
      "Si una irritación no mejora en unos días, consulta a tu farmacéutico o dermatólogo.",
    ],
  },
  {
    slug: "bricolaje-sin-miedo",
    title: "Pequeñas reparaciones en casa que puedes hacer tú mismo",
    excerpt:
      "Colgar un cuadro, arreglar lo que se rompe y ajustar lo que se afloja: con un kit básico y adhesivos modernos no hace falta llamar a nadie.",
    image: IMG_CAT.bricolaje,
    minutes: 4,
    category: "herramientas-bricolaje",
    products: ["jorest-kit-precision", "pattex-no-more-nails", "loctite-super-glue-monodosis"],
    intro:
      "La mayoría de las pequeñas averías domésticas no necesitan un profesional: necesitan diez minutos y la herramienta correcta. Este es el kit mínimo para resolver el 90 % de los arreglos que surgen en una casa.",
    sections: [
      {
        heading: "Un kit básico bien elegido",
        body: "No hace falta una caja de herramientas enorme: un juego de destornilladores de precisión con las puntas habituales cubre desde apretar las patillas de las gafas hasta abrir un portátil o montar un mueble pequeño.",
      },
      {
        heading: "Colgar sin taladrar",
        body: "Los adhesivos de montaje actuales aguantan kilos sin hacer un solo agujero: cintas doble cara extrafuertes para objetos ligeros y adhesivos de construcción tipo «no más clavos» para estanterías y accesorios. Ideal para pisos de alquiler.",
      },
      {
        heading: "Reparar en lugar de tirar",
        body: "Una monodosis de pegamento instantáneo rescata cerámica, plástico, madera y goma en segundos. El formato monodosis evita el clásico problema del tubo que se seca antes de usarlo por segunda vez.",
      },
    ],
    tips: [
      "Limpia y seca las superficies antes de pegar: el 90 % de los fallos de adhesivo son por polvo o grasa.",
      "Prueba primero el peso del objeto colgado tirando suavemente hacia abajo.",
      "Guarda el kit en un sitio fijo y conocido: una reparación rápida empieza por encontrar la herramienta.",
    ],
  },
  {
    slug: "ideas-de-regalo",
    title: "Ideas de regalo prácticas que aciertan todo el año",
    excerpt:
      "El mejor regalo no es el más caro: es el que se usa. Ideas útiles para cumpleaños, Navidades, verano y cualquier fecha señalada.",
    image: IMG_CAT.regalos,
    minutes: 5,
    category: null,
    products: ["fire-tv-stick-hd", "celimax-retinal", "hayayu-mochila-ryanair"],
    intro:
      "Regalar bien es más fácil de lo que parece si se sigue una regla: regala algo que la persona vaya a usar en su día a día, no algo que te gustaría a ti. Esta guía reúne ideas prácticas ordenadas por momento del año y por tipo de persona.",
    sections: [
      {
        heading: "Regala algo que se use, no algo que se guarde",
        body: "Los regalos que más se agradecen al cabo de un año son los prácticos: un dispositivo que convierte la tele en inteligente, un accesorio de viaje que se estrena en el primer fin de semana o un básico de cuidado personal que se acaba y se repite.",
      },
      {
        heading: "Por temporada: qué funciona en cada época",
        body: "En verano triunfan los accesorios de viaje y playa; en Navidades, la tecnología y los productos de hogar; en la vuelta a la rutina de septiembre, la organización y el material de escritorio. Adelantar el regalo a la temporada correcta duplica su acierto.",
      },
      {
        heading: "El comodín infalible: útil, bonito y a buen precio",
        body: "Cuando no conoces bien a la persona, elige algo de uso universal: un accesorio de streaming para la tele, un producto de cosmética coreana de los más vendidos o una buena mochila de cabina. Regalos de menos de 40 € que se usan a diario.",
      },
    ],
    tips: [
      "Mira el día a día de la persona, no tu propio gusto: ahí está la pista.",
      "Un regalo práctico bien presentado impresiona más que uno caro envuelto a la carrera.",
      "En Amazon puedes marcar «es un regalo» para que llegue sin precio y con opción de devolución.",
    ],
  },
  {
    slug: "regalos-navidad",
    title: "Regalos de Navidad prácticos que no acaban en un cajón",
    excerpt:
      "Amigo invisible, familia, compañeros: ideas de regalo navideño útiles y a buen precio que se estrenan la misma semana.",
    image: IMG_CAT.regalosNavidad,
    minutes: 5,
    category: null,
    products: ["echo-dot-5", "fire-tv-stick-4k-plus", "biodance-collagen-mask"],
    intro:
      "La Navidad concentra más regalos fallidos que ninguna otra época, casi siempre por lo mismo: se regala por salir del paso. La clave es elegir algo que la persona use ya, en pleno invierno, no algo «para algún día».",
    sections: [
      {
        heading: "Tecnología que se estrena el mismo día",
        body: "Los dispositivos para la tele o un altavoz inteligente tienen algo único en Navidad: se instalan la misma tarde de Reyes o de Nochebuena, con la familia alrededor. Son regalos con efecto inmediato y precio contenido.",
      },
      {
        heading: "Belleza y autocuidado: el acierto del invierno",
        body: "Con el frío, la piel pide hidratación extra y los productos de cosmética coreana o los packs de mascarillas se usan de verdad entre semana de fiestas y vuelta al trabajo. Mejor un producto de los más vendidos que una apuesta rara.",
      },
      {
        heading: "Amigo invisible sin estrés",
        body: "Con presupuesto de 10 a 30 € manda la regla de oro: consumible o usable a diario. Un buen pack de cuidado personal, un accesorio para el móvil o algo para su afición conocida siempre supera al objeto decorativo.",
      },
    ],
    tips: [
      "Compra con margen: en diciembre los envíos se saturan y los precios de lo popular suben.",
      "Marca la opción «es un regalo»: llega sin precio y con devolución ampliada de enero.",
      "Si dudas entre dos opciones, elige la que tenga más valoraciones reales.",
    ],
  },
  {
    slug: "regalos-verano",
    title: "Regalos de verano: ideas que se usan en vacaciones",
    excerpt:
      "Cumpleaños de verano, escapadas y barbacoas: regalos que acompañan el viaje, la terraza y los días largos.",
    image: IMG_CAT.regalosVerano,
    minutes: 4,
    category: null,
    products: ["matein-mochila-expandible", "yissvic-raqueta-mosquitos", "termometro-inalambrico"],
    intro:
      "Un regalo de verano tiene una ventaja enorme: se estrena enseguida. Cualquier cosa relacionada con viajar, con la terraza o con soportar mejor el calor se pone en uso en cuestión de días, no de meses.",
    sections: [
      {
        heading: "Para el que siempre está de viaje",
        body: "Una mochila de cabina que cumple las medidas de las low-cost es el regalo estrella del verano: cabe la ropa de una semana, se lleva gratis en el avión y se usa en cada escapada del año. Práctico y con mucho valor percibido.",
      },
      {
        heading: "Para las noches de terraza",
        body: "Cenas al aire libre, barbacoas y sobremesas largas tienen un enemigo declarado: los mosquitos. Una raqueta eléctrica recargable o un buen termómetro de interior/exterior son regalos sencillos que el anfitrión agradece esa misma noche.",
      },
      {
        heading: "El detalle de última hora",
        body: "¿Te han invitado a una comida o cumpleaños improvisado? Los accesorios de playa, piscina y jardín tienen precios muy razonables, llegan rápido en verano y siempre encuentran uso antes de que acabe la temporada.",
      },
    ],
    tips: [
      "En verano regala pensando en planes: viaje, playa, terraza o piscina.",
      "Los artículos de temporada se agotan: no dejes el regalo para el último día.",
      "Un accesorio de viaje acierta aunque no sepas el destino de sus vacaciones.",
    ],
  },
  {
    slug: "regalos-vuelta-al-cole",
    title: "Vuelta al cole (y a la oficina): regalos útiles para septiembre",
    excerpt:
      "Septiembre es la otra temporada de regalos: material que se usa cada día, organización y pequeños caprichos de escritorio.",
    image: IMG_CAT.regalosCole,
    minutes: 4,
    category: null,
    products: ["casio-fx991sp", "niimbot-d110", "amazon-basics-pizarra"],
    intro:
      "Septiembre funciona como un enero pequeño: propósitos, rutinas nuevas y material que estrenar. Es el momento perfecto para regalar cosas de estudio y escritorio, porque se usan a diario durante todo el curso.",
    sections: [
      {
        heading: "Para estudiantes: lo que de verdad se usa",
        body: "Olvida los detalles decorativos: una calculadora científica reglamentaria, buenos bolígrafos de gel o una etiquetadora para organizar carpetas y material son regalos que se usan cinco días a la semana durante meses.",
      },
      {
        heading: "Para quien trabaja en casa",
        body: "La vuelta al trabajo presencial o al teletrabajo es el momento de mejorar el puesto: una pizarra para organizar la semana o un organizador de escritorio cambian más la rutina que muchos regalos caros.",
      },
      {
        heading: "Organización: el regalo invisible que más dura",
        body: "Etiquetar carpetas, cargadores y cajones al inicio del curso ahorra cientos de pequeñas búsquedas a lo largo del año. Una etiquetadora portátil es de esos regalos que nadie espera y todos acaban usando.",
      },
    ],
    tips: [
      "En septiembre regala rutina: estudio, escritorio y organización.",
      "Para estudiantes, comprueba que el modelo de calculadora esté permitido en su curso.",
      "Aprovecha las semanas previas: el material escolar se encarece en la primera quincena de septiembre.",
    ],
  },
  {
    slug: "ofertas-prime-day-black-friday",
    title: "Prime Day y Black Friday: cómo cazar las ofertas que de verdad valen la pena",
    excerpt:
      "Los dos picos de descuentos del año concentran miles de rebajas... y algunas trampas. La estrategia para comprar bien y los productos que históricamente más bajan.",
    image: IMG_CAT.ofertas,
    minutes: 5,
    category: null,
    products: ["echo-dot-5", "fire-tv-stick-4k-plus", "oralb-vitality-pro"],
    intro:
      "El Prime Day (en verano) y el Black Friday (a finales de noviembre) son los dos momentos del año con más descuentos reales en Amazon. Pero entre miles de carteles rojos hay ofertas buenísimas y otras infladas. La diferencia entre ahorrar de verdad y picar en el reclamo está en prepararse antes.",
    sections: [
      {
        heading: "Prepara la lista antes, compra sin arrepentirte",
        body: "Semanas antes del evento, decide qué necesitas de verdad y apunta su precio normal. Cuando llegue el día, compararás el descuento contra ese precio real y no contra el tachado que muestre la etiqueta. Así compras por necesidad y con criterio, no por impulso.",
      },
      {
        heading: "Cómo saber si un descuento es real",
        body: "Algunos vendedores suben el precio semanas antes para que el porcentaje de rebaja parezca mayor. La defensa es sencilla: mira si el precio de oferta es bajo comparado con las semanas anteriores (no con el PVP) y compara la misma referencia en otra tienda. Un 40 % de rebaja sobre un precio inflado puede ser peor que un 15 % honesto.",
      },
      {
        heading: "Lo que más baja (y lo que casi nunca baja)",
        body: "La tecnología propia de Amazon (altavoces Echo, Fire TV), el pequeño electrodoméstico y el cuidado personal encabezan las rebajas reales cada año. En cambio, consolas o móviles recién lanzados apenas se mueven de precio: si es lo que buscas, no esperes milagros.",
      },
    ],
    tips: [
      "Las ofertas flash duran horas: si el precio es bueno de verdad, no lo dejes para la noche.",
      "Revisa la cesta antes de pagar: en Black Friday algunos precios cambian varias veces al día.",
      "Si el descuento es inferior al 10 %, casi siempre puedes esperar a otra oferta mejor.",
    ],
  },
];
